import {
  getCartTotalCentsWithServerOrderSurcharges,
  getCartWithServerOrderSurcharges,
} from 'features/cart/utils/server-order-surcharges';

import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

type FeeLike = {
  readonly name?: string | null;
  readonly totalCents?: number | null;
};

type CartLike = {
  readonly fees?: ReadonlyArray<FeeLike | null> | null;
  readonly subTotalCents?: number | null;
  readonly taxCents?: number | null;
  readonly totalCents?: number | null;
};

export const useCartWithServerOrderSurcharges = <Cart extends CartLike | null | undefined>(
  cart: Cart
) => {
  const enablePosOrderSurchargesAsFees = Boolean(
    useFlag(LaunchDarklyFlag.ENABLE_POS_ORDER_SURCHARGES_AS_FEES)
  );
  const cartTotalCents = getCartTotalCentsWithServerOrderSurcharges({
    cart,
    enablePosOrderSurchargesAsFees,
  });

  return {
    cart: getCartWithServerOrderSurcharges({
      cart,
      enablePosOrderSurchargesAsFees,
    }),
    cartTotalCents,
    enablePosOrderSurchargesAsFees,
  };
};
